import React from 'react';
import loadable from '@loadable/component'

import withPage, { fetchSlugInfo } from '../page';


const loadData = async (urlParams, store, querySelector) => {
    const { dir, slug, filters } = urlParams;
    const fullSlug = `/${dir}/${slug}${filters ? '/' + filters : ''}`;
    await store.dispatch(fetchSlugInfo(fullSlug, querySelector));

    const { slugInfo, redirects, basename } = store.getState();

    const needRedirect = !slugInfo || slugInfo.error || (redirects && redirects.count !== 0);

    const { destination = `${basename}/slp/weekly-deals`, status = 301 } = redirects;
    if (needRedirect) return Promise.resolve({ status, destination });

    return Promise.resolve(slugInfo);
};

const ConfigureAttachContainer = ({ slugInfo = {} }) => {
    return <div>{'CONFIGURATOR ATTACH PAGE '}</div>
}

export default {
    component: withPage(ConfigureAttachContainer, { wrapperClassName: 'configure-attach-root', disablePageCall: true, showWordCloud: true, useV2: true }),
    loadData: loadData
};
